<template>
  <div class="UpdateUserComponent">

    

      <b-form-group id="input-group-FirstName" :label="lang.label_FirstName" label-for="input-2">
        <b-form-input
          id="input-FirstName"
          v-model="form.FirstName"
          :placeholder="lang.placeholder_FirstName"
          size="sm"
          required
          aria-describedby="input-FirstName-feedback"
          :state="validation_FirstName"
        ></b-form-input>

        <b-form-invalid-feedback id="input-FirstName-feedback" :state="validation_FirstName">
          {{lang.validinfo_FirstName}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-LastName" :label="lang.label_LastName" label-for="input-2">
        <b-form-input
          id="input-LastName"
          v-model="form.LastName"
          :placeholder="lang.placeholder_LastName"
          size="sm"
          required
          aria-describedby="input-LastName-feedback"
          :state="validation_LastName"
        ></b-form-input>

        <b-form-invalid-feedback id="input-LastName-feedback" :state="validation_LastName">
          {{lang.validinfo_LastName}}
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- <b-form-group id="input-group-Login" :label="lang.label_Login" label-for="input-2">
        <b-form-input
          id="input-Login"
          v-model="form.Login"
          :placeholder="lang.placeholder_Login"
          size="sm"
          required
          aria-describedby="input-Login-feedback"
          :state="validation_LastName"
        ></b-form-input>

        <b-form-invalid-feedback id="input-Login-feedback" :state="validation_Login">
          {{lang.validinfo_Login}}
        </b-form-invalid-feedback>
      </b-form-group> -->

      <b-form-group id="input-group-Password" :label="lang.label_Password" label-for="input-2">
        <b-form-input
          type="password"
          id="input-Password"
          v-model="form.Password"
          :placeholder="lang.placeholder_Password"
          size="sm"
          required
          aria-describedby="input-Password-feedback"
          :state="validation_LastName"
        ></b-form-input>

        <b-form-invalid-feedback id="input-Password-feedback" :state="validation_Password">
          {{lang.validinfo_Password}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-Email" :label="lang.label_Email" label-for="input-2">
        <b-form-input
          type="email"
          id="input-Email"
          v-model="form.Email"
          :placeholder="lang.placeholder_Email"
          size="sm"
          required
          aria-describedby="input-Email-feedback"
          :state="validation_Email"
        ></b-form-input>

        <b-form-invalid-feedback id="input-Email-feedback" :state="validation_Email">
          {{lang.validinfo_Email}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-Role" :label="lang.label_Role" label-for="input-2">
        <b-form-select v-model="form.Role" :options="options" size="sm"></b-form-select>
        <b-form-invalid-feedback id="input-Role-feedback" :state="validation_Email">
            {{lang.validinfo_Role}}
        </b-form-invalid-feedback>
      </b-form-group>

      
      <PermissionGroupComponent v-show="globalSettings.advancedPermissions == true" :lang="lang.PermissionGroups" :defaultSettings="{ groups: basicGroupId, isId: true, parent: 'user' }"></PermissionGroupComponent>

      <b-form-group id="input-group-IsActive">

        <b-form-checkbox v-model="form.IsActive" value="true" unchecked-value="false">{{lang.label_IsActive}}</b-form-checkbox>
      </b-form-group>


    
  </div>
</template>

<script>
import PermissionGroupComponent from '@/components/shared/PermissionGroupComponent'
import { mapGetters } from 'vuex'

export default {
  name: "UpdateUserComponent",
  components: {
    PermissionGroupComponent


  },
  props:{
    lang: Object
  },
  data () {
    return {
      form: {

        FirstName: this.$store.getters.createUserForm.FirstName,
        LastName: this.$store.getters.createUserForm.LastName,
        Login: this.$store.getters.createUserForm.Email,
        Password: "",
        Email: this.$store.getters.createUserForm.Email,
        Role: this.$store.getters.createUserForm.Role,
        IsActive: this.$store.getters.createUserForm.IsActive,
        Groups: this.$store.getters.createUserForm.groups
      },
      basicGroupId: this.$store.getters.createUserForm.groups,
      inputStatus: null,

      selected: null,
      options: [
        { value: null, text: 'Choose...' },
        { value: 'Admin', text: 'Admin' },
        { value: 'Approver', text: 'Approver' },
        { value: 'User', text: 'User' },
        { value: 'Reader', text: 'Reader' },
      ],
      adminGroupId: null
    }
  },
  computed: {
    ...mapGetters([

      'globalSettings'
    ]),
    validation_FirstName() {
      
      
      if (this.form.FirstName.length == 0){
        return null;
      }
      return this.form.FirstName.length > 0
    },
    validation_LastName() {
      if (this.form.LastName.length == 0){
        return null;
      }
      return this.form.LastName.length > 0
    },
    validation_Login() {
      if (this.form.Login.length == 0){
        return null;
      }
      return this.form.Login.length > 0
    },
    validation_Password() {
      console.log(this.form)
      if (this.form.Password.length > 0){
        return this.form.Password.length >= 6
      }
      return null;
    },
    validation_Email() {
      if (this.form.Email.length == 0){
        return null;
      }
      return this.form.Email.length > 0
    },
    validation_Role() {
      if (this.form.Role == null){
        return null;
      }
      return this.form.Role != null
    },
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }

    },
    permissionGroup() {

      return this.$store.getters.permissionGroup
    }
  },
  created() {
    this.getGroups();

  },
  updated(){
    

    this.form.Login = this.form.Email;

    this.$store.dispatch(this.$store.getters.sectionPrefix + "_createUserForm", this.form);
    
  },
  watch: {
    form: {
      handler: function (newVal) {

        if (newVal.Role == "Admin") {
          
          this.addAdminId();
        } else {
          this.removeAdminId();
        }


      },
      deep: true


    },
  },
  methods: {
    addAdminId() {

      let trig = false;
      for (let i = 0, lei = this.basicGroupId.length; i < lei; i++) {

        if (this.basicGroupId[i] == this.adminGroupId) {
          trig = true;
          break;
        }
      }
      if (trig == false) {
        this.basicGroupId.push(this.adminGroupId);
      }
    },
    removeAdminId() {

      let index = null;
      for (let i = 0, lei = this.basicGroupId.length; i < lei; i++) {
        if (this.basicGroupId[i] == this.adminGroupId) {
          index = i;
          break;
        }
      }
      if (index != null) {

        this.basicGroupId.splice(index, 1);
      }
    },
    getGroups() {

      let _vue = this;
      //_vue.basicGroupId = [];

      this.$store.dispatch("u_getGroups")
        .then(function (result) {

          console.log(result.data)

          if (result.status == "OK") {

            if (result.data != null) {


              for (let i = 0, lei = result.data.length; i < lei; i++) {
                
                if (result.data[i].groupName == "Admins") {
                  //_vue.adminGroupId = result.data[i].groupId;
                }
                

              }
            }
          }




        })
    },
  }
}
</script>
<style lang="scss">
  .UpdateUserComponent{

  }



</style>



// WEBPACK FOOTER //
// src/components/shared/UpdateUserComponent.vue